<div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title" translate>
        lblSendNotification
        <span class="font16 ml-3 text-light float-none">
            {{WOnumber}} - {{DealerName}}
        </span>
    </h4>
    <button type="button" class="close" aria-label="Close" (click)="OnClose()">
        <span aria-hidden="true">
            ×
        </span>
    </button>
</div>
<div class="modal-body">
    <div class="popup-vcenter">
        <div class="row">
            <div class="col col-2">
                <div class="form-group">
                    <label for="Language" translate>lblLanguage</label>
                    <ng-select [items]="languageList" bindLabel="value" bindValue="key" placeholder="Select Language"
                        (change)="onLanguageChange()" [(ngModel)]="selectedLaguage" [clearable]="false" [searchable]="false">
                        <ng-template ng-label-tmp let-item="item">
                            <img height="15" width="20" [src]="getFlagImage(item.flagName)" alt="" />
                            <strong class="lang">{{item.value}}</strong>
                        </ng-template>
                        <ng-template ng-option-tmp let-item="item" let-index="index">
                            <img height="15" width="20" [src]="getFlagImage(item.flagName)" alt="" />
                            <strong class="lang">{{item.value}}</strong>
                        </ng-template>
                    </ng-select>
                </div>
            </div>
            <div class="col col-2">
                <div class="form-group">
                    <label for="Channel1" translate>lblChannel</label>
                    <select class="form-control" id="Channel1" aria-describedby="Select" [(ngModel)]="selectedChannel"
                        (change)="onFilter()">
                        <option *ngFor="let templateType of templateTypeList" [value]="templateType.value">
                            {{templateType.text}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col col-2">
                <div class="form-group" *ngIf="selectedChannel != 3" >
                    <label for="Channel1" translate>lblSection</label>
                    <select class="form-control" id="module" aria-describedby="Select" [(ngModel)]="selectedModule"
                        (change)="onModuleChange()">
                        <option selected translate [ngValue]=null>lblSelectSection</option>
                        <option *ngFor="let m of moduleList" [value]="m.id">
                            {{m.name}}
                        </option>
                    </select>
                </div>
                <div class="form-group" *ngIf="selectedChannel == 3" >
                    <label for="Channel1" translate>lblSection</label>
                    <select class="form-control" id="module" aria-describedby="Select" [(ngModel)]="selectedModule"
                        (change)="onModuleChange()">
                        <option selected translate [ngValue]=null>lblSelectSection</option>
                        <option *ngFor="let m of moduleListFilterd" [value]="m.id">
                            {{m.name}}
                        </option>
                    </select>
                </div>
            </div>
            <div class="col col-2">
                <div class="form-group" *ngIf="selectedChannel != 3" >
                    <label for="Channel1" translate>lblUserType</label>
                    <select class="form-control" id="module" aria-describedby="Select" [(ngModel)]="selectedUserType"
                        (change)="onUserTypeChange()">
                        <option selected translate [ngValue]=null>lblSelectUserType</option>
                        <option *ngFor="let u of userTypeList" [value]="u.id">
                            {{u.name}}
                        </option>
                        
                    </select>
                </div>
                <div class="form-group" *ngIf="selectedChannel == 3" >
                    <label for="Channel1" translate>lblUserType</label>
                    <select class="form-control" id="module" aria-describedby="Select" [(ngModel)]="selectedUserType"
                        (change)="onUserTypeChange()">
                        <option selected translate [ngValue]=null>lblSelectUserType</option>
                        <option *ngFor="let u of userTypeListFilterd" [value]="u.id">
                            {{u.name}}
                        </option>
                        
                    </select>
                </div>
            </div>
            <div class="col col-4">
                <div class="form-group">
                    <label for="Channel1" translate>lblTemplate</label>
                    <select class="form-control" id="Channel1" aria-describedby="Select"
                        (change)="onTemplateChange($event.currentTarget.value)">templateList
                        <option *ngFor="let template of templateListFiltered"
                            [value]="template.id">
                           {{getSectionName(template.applicationId)}} - {{getUserTypeName(template.userTypeId)}} - {{template.name}}
                        </option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col col-12" *ngIf="EditManualNotificationForm.templateTypeIds != channel.SMS">
                <div class="form-group">
                    <label for="Channel2" translate>lblSubject</label>
                    <textarea class="form-control" maxlength="120" [(ngModel)]="EditManualNotificationForm.subject"
                        (ngModelChange)="ValidateFields()">
                        </textarea>
                </div>
            </div>
            <div class="col col-12">
                <div class="form-group">
                    <label for="Channel2" translate>lblBody</label>
                                                                  
                    <quill-editor format= "html" name="body" [(ngModel)]="EditManualNotificationForm.body" 
                    (ngModelChange)="ValidateFields()" 
                    *ngIf="EditManualNotificationForm.templateTypeIds != channel.SMS && EditManualNotificationForm.templateTypeIds != channel.PushNotification"
                    [modules]="options" required></quill-editor>
                    
                    <textarea name="body" [(ngModel)]="EditManualNotificationForm.body" class="form-control mb-2"
                        (ngModelChange)="ValidateFields()"
                        *ngIf="EditManualNotificationForm.templateTypeIds == channel.SMS || EditManualNotificationForm.templateTypeIds == channel.PushNotification"
                        required></textarea>
                </div>
            </div>
        </div>
        <div class="table-responsive">
            <table class="tablest1">
                <thead>
                    <tr>
                        <th scope="col" style="width: 40px" class="text-center" translate>lblTo</th>
                        <th scope="col" translate>lblRole</th>
                        <th scope="col" translate>lblEmail</th>
                        <th scope="col" translate>lblName</th>
                        <th scope="col" translate>lblMobileNo</th>
                    </tr>
                </thead>
                <tbody>
                    <ng-container *ngFor="let notificationUser of notificationUserList; let in=index;let last=last">
                        <tr>
                            <td>
                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="customCheck{{in}}"
                                        [disabled]="notificationUser.isDisabled" [checked]="notificationUser.isSelected"
                                        (change)="notificationUser.isSelected=!notificationUser.isSelected">
                                    <label class="custom-control-label" for="customCheck{{in}}"></label>
                                </div>
                            </td>
                            <td translate>{{notificationUser.roleName}}</td>
                            <td translate>{{notificationUser.email}}</td>
                            <td translate>{{notificationUser.name}}</td>
                            <td translate><span>{{+(notificationUser.mobileCode) > 0 ? '+'+notificationUser.mobileCode : ''}}{{+(notificationUser.mobile) > 0 ? '-'+notificationUser.mobile : ''}}</span></td>
                        </tr>
                    </ng-container>
                </tbody>
            </table>
        </div>
    </div>
</div>
<div class="modal-footer justify-content-between">
    <div class="mr-auto">
        <button type="button" class="btn btn-primary mr-sm-2" translate (click)="NotificationPreview(viewPreView)"
            [disabled]="!saveButtonEnable">
            <em class="far fa-eye"></em> lblPreview
        </button>
        <button type="button" class="btn btn-primary mr-sm-2" [disabled]="!saveButtonEnable" translate
            (click)="SendNotification()">
            <em class="fas fa-paper-plane"></em> lblSendNotification
        </button>
        <button type="button" class="btn btn-secondary mr-sm-2" (click)="OnClose()" translate>
            <em class="far fa-times-circle"></em> lblCancel
        </button>
    </div>
    <div class="ml-auto">
        <button type="button" class="btn btn-outline-primary mr-sm-2" (click)="OpenMyRecipientModel()" translate>
            <em class="fas fa-plus"></em> lblMyRecipient
        </button>
        <button type="button" class="btn btn-outline-primary" (click)="OpenAddRecipientModel()" translate>
            <em class="fas fa-plus"></em> lblAddRecipient
        </button>
    </div>
</div>

<ng-template #viewPreView let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblPreview
        </h4>
        <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')"><span
                aria-hidden="true">×</span></button>
    </div>
    <div class="modal-body table-responsive remark">
        <div class="row">
            <div class="col col-12" *ngIf="EditManualNotificationForm.templateTypeIds != channel.SMS">
                <div class="form-group">
                    <label for="Channel2" translate>lblSubject</label>
                    <div>{{templateLegendResponseModel.item1}}</div>
                </div>
            </div>
            <div class="col col-12">
                <div class="form-group">
                    <label for="Channel2" translate>lblBody</label>
                    <div class="" [innerHtml]="templateLegendResponseModel.item2"></div>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button type="button" class="btn btn-primary mr-sm-2" translate
            (click)="SendNotification(); modal.close('Cancel click')">
            <em class="fas fa-paper-plane"></em> lblSendNotification
        </button>
        <button type="button" class="btn btn-secondary btn-md" (click)="modal.close('Cancel click')"
            translate>lblCancel</button>
    </div>
</ng-template>